import type DomObservabilityService from "./services/dom-observability/dom-observability.service"
import type StorageService from "./services/storage/storage.service"
import type StaticService from "./services/static/static.service"
import type ImageEditService from "./services/image-edit/image-edit.service"
import type CacheService from "./services/cache/cache.service"
import type BootstrapService from "./services/bootstrap/bootstrap.service"

/**
 * Used to instantiate and initialize services
 * Static service needs to be injected here so that it can be accessed statically
 * Unused services are injected so that they are instantiated by Angular DI, otherwise the app breaks
 */
export function runBlock(
  DomObservabilityService: DomObservabilityService,
  StorageService: StorageService,
  StaticService: StaticService,
  ImageEditService: ImageEditService,
  CacheService: CacheService,
  BootstrapService: BootstrapService,
  $log: angular.ILogService,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  constants: any,
): void {
  "ngInject"

  BootstrapService.init()

  $log.info("starting classkick", constants.version)
}
